import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type SetOrderEmailSettingsMutationVariables = Types.Exact<{
  input: Types.SetOrderEmailSettingsInput;
}>;


export type SetOrderEmailSettingsMutation = { __typename?: 'Mutation', setOrderEmailSettings: { __typename?: 'OrderEmailSettingsPayload', orderEmailSettings?: { __typename?: 'OrderEmailSettingsData', tenantId: string, docType: Types.OrderEmailDocType, emailSubject?: string | null, emailBody?: string | null, senderId?: string | null, recipients: Array<string>, includeSalesPersonCc: boolean, includeServicingSiteManagerCc: boolean, updatedBy: string, updatedAt: Types.TDateISO } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetOrderEmailEnablementMutationVariables = Types.Exact<{
  input: Types.SetOrderEmailEnablementInput;
}>;


export type SetOrderEmailEnablementMutation = { __typename?: 'Mutation', setOrderEmailEnablement: { __typename?: 'OrderEmailSettingsPayload', orderEmailSettings?: { __typename?: 'OrderEmailSettingsData', tenantId: string, docType: Types.OrderEmailDocType, enabled: boolean, channel: Types.OrderEmailChannel } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetInvoiceEmailChannelMutationVariables = Types.Exact<{
  input: Types.SetInvoiceEmailChannelInput;
}>;


export type SetInvoiceEmailChannelMutation = { __typename?: 'Mutation', setInvoiceEmailChannel: { __typename?: 'OrderEmailSettingsPayload', orderEmailSettings?: { __typename?: 'OrderEmailSettingsData', tenantId: string, docType: Types.OrderEmailDocType, enabled: boolean, channel: Types.OrderEmailChannel } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const SetOrderEmailSettingsDocument = new TypedDocumentString(`
    mutation SetOrderEmailSettings($input: SetOrderEmailSettingsInput!) {
  setOrderEmailSettings(input: $input) {
    orderEmailSettings {
      tenantId
      docType
      emailSubject
      emailBody
      senderId
      recipients
      includeSalesPersonCc
      includeServicingSiteManagerCc
      updatedBy
      updatedAt
    }
    errors {
      code
      message
    }
  }
}
    `);
export const SetOrderEmailEnablementDocument = new TypedDocumentString(`
    mutation SetOrderEmailEnablement($input: SetOrderEmailEnablementInput!) {
  setOrderEmailEnablement(input: $input) {
    orderEmailSettings {
      ...OrderEmailSettingsEnablement
    }
    errors {
      code
      message
    }
  }
}
    fragment OrderEmailSettingsEnablement on OrderEmailSettingsData {
  tenantId
  docType
  enabled
  channel
}`);
export const SetInvoiceEmailChannelDocument = new TypedDocumentString(`
    mutation SetInvoiceEmailChannel($input: SetInvoiceEmailChannelInput!) {
  setInvoiceEmailChannel(input: $input) {
    orderEmailSettings {
      ...OrderEmailSettingsEnablement
    }
    errors {
      code
      message
    }
  }
}
    fragment OrderEmailSettingsEnablement on OrderEmailSettingsData {
  tenantId
  docType
  enabled
  channel
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    SetOrderEmailSettings: build.mutation<SetOrderEmailSettingsMutation, SetOrderEmailSettingsMutationVariables>({
      query: (variables) => ({ document: SetOrderEmailSettingsDocument, variables })
    }),
    SetOrderEmailEnablement: build.mutation<SetOrderEmailEnablementMutation, SetOrderEmailEnablementMutationVariables>({
      query: (variables) => ({ document: SetOrderEmailEnablementDocument, variables })
    }),
    SetInvoiceEmailChannel: build.mutation<SetInvoiceEmailChannelMutation, SetInvoiceEmailChannelMutationVariables>({
      query: (variables) => ({ document: SetInvoiceEmailChannelDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useSetOrderEmailSettingsMutation, useSetOrderEmailEnablementMutation, useSetInvoiceEmailChannelMutation } = injectedRtkApi;
